import { render, staticRenderFns } from "./view-quick-game.vue?vue&type=template&id=418b5505&scoped=true&"
import script from "./view-quick-game.vue?vue&type=script&lang=js&"
export * from "./view-quick-game.vue?vue&type=script&lang=js&"
import style0 from "./view-quick-game.vue?vue&type=style&index=0&id=418b5505&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418b5505",
  null
  
)

export default component.exports